var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomFurnace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 191,
    viewBox: "0 0 154 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 73,
    height: 149,
    y: 42,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 72,
    height: 148,
    x: 0.5,
    y: 42.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M83.033 31C83.772 14.575 96.708 1.326 113 .094V0h41v22h-39.598c-5.069.466-8.892 4.27-9.402 9.324V74h-.185c-1.738 16.302-15.536 29-32.3 29-.172 0-.343-.001-.515-.004V81.332c.17.008.343.012.516.012 5.527 0 9.86-4.142 10.484-9.491V31h.033z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M83.5 31.5l-.003 40.41c-.664 5.686-5.281 9.934-10.981 9.934H72.5V102.5h.016c16.387 0 30.078-12.384 31.802-28.553l.048-.447h.134l.003-42.226c.534-5.296 4.55-9.284 9.899-9.774H153.5V.5h-40v.057l-.462.035c-16.074 1.216-28.78 14.292-29.505 30.43l-.022.478H83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M72.942 80.931L73 103H37.092c-5.244 0-10.184-1.705-14.289-4.932C17.21 93.674 14 87.088 14 79.999 14 67.318 24.359 57 37.092 57c10.761 0 20.245 7.59 22.55 18.049l.084.368c.955 3.108 3.814 5.355 7.119 5.514h6.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M72.443 81.431H66.82a8.384 8.384 0 01-7.581-5.901l-.086-.374C56.9 64.928 47.619 57.5 37.092 57.5 24.635 57.5 14.5 67.594 14.5 79.999c0 6.936 3.138 13.377 8.612 17.676 4.016 3.157 8.848 4.825 13.98 4.825h35.407l-.056-21.069z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M46.999 80.184C46.9 85.597 42.415 90 37 90a9.89 9.89 0 01-6.187-2.145A9.95 9.95 0 0127 80C27 74.485 31.486 70 37 70c5.515 0 10 4.485 10 9.999l-.001.185z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M46.499 80.178l.001-.18c0-5.237-4.261-9.498-9.5-9.498-5.238 0-9.5 4.262-9.5 9.499a9.45 9.45 0 003.622 7.464A9.39 9.39 0 0037 89.5c5.142 0 9.404-4.183 9.499-9.322z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M11 137h11v21H11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M11.5 137.5h10v20h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M11 137h11v13H11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M11.5 137.5h10v12h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M0 117h73v5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M.5 117.5h72v4H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomFurnace);
export default __webpack_public_path__ + "static/media/RoomFurnace.653397cc47325319c218174fa784347a.svg";
export { ForwardRef as ReactComponent };